import { PathTypeAccountInfo } from "models/commonModel";
import AgencyRefund from "pages/account/account-option/AgencyRefund";
import AgentMember from "pages/account/account-option/AgentMember";
import AgentRegister from "pages/account/account-option/AgentRegister";
import AgentTeamBalance from "pages/account/account-option/AgentTeamBalance";
import AgentSign from "pages/account/account-option/AgentSign";
import BankAccount from "pages/account/account-option/BankAccount";
import FundAccountTransfer from "pages/account/account-option/FundAccountTransfer";
import FundBet from "pages/account/account-option/FundBet";
import GiftCodeAccount from "pages/account/account-option/GiftCodeAccount";
import NotiftyInbox from "pages/account/account-option/NotiftyInbox";
import NotiftyAll from "pages/account/account-option/NotifyAll";
import PersonalInfo from "pages/account/account-option/PersonalInfo";
import PresentDetail from "pages/account/account-option/PresentDetail";
import StatsAgency from "pages/account/account-option/StatsAgency";
import StatsDaily from "pages/account/account-option/StatsDaily";
import StatsGeneral from "pages/account/account-option/StatsGeneral";
import WalletDepositHistory from "pages/account/account-option/WalletDepositHistory";
import DepositPage from "pages/deposit/DepositPage";
import FundTransfer from "pages/fund-transfer/FundTransfer";
import WithdrawPage from "pages/withdraw/WithDraw";

interface AccountItem {
    label: string;
    path: PathTypeAccountInfo;
    icon: any;
}

interface GroupAccountItem {
    title: string;
    id: string;
    group: AccountItem[];
}

interface OptionAccountComponent {
    path: PathTypeAccountInfo;
    component: React.FC;
}

export const optionAccountMenu: GroupAccountItem[] = [
    {
        title: 'Tài khoản',
        id: 'account',
        group: [
            {
                label: 'Thông tin cá nhân',
                path: 'personal-info',
                icon: require('assets/images/icons/account/account-1.svg'),
            },
            {
                label: 'Tài khoản ngân hàng',
                path: 'bank-account',
                icon: require('assets/images/icons/account/account-2.svg'),
            },

            {
                label: 'Quà tặng',
                path: 'gift-code',
                icon: require('assets/images/icons/account/account-3.svg'),
            },
        ],
    },
    {
        title: 'Đại Lý',
        id: 'agency',
        group: [
            { label: 'Đăng ký thành viên', path: 'agent-sign', icon: require('assets/images/icons/account/agency-1.svg') },
            { label: 'Cấp dưới', path: 'agent-member', icon: require('assets/images/icons/account/agency-2.svg') },
            { label: 'Liên kết đăng ký', path: 'agent-reg', icon: require('assets/images/icons/account/agency-3.svg') },
        ],
    },
    {
        title: 'Lịch Sử',
        id: 'history',

        group: [
            { label: 'Biến động số dư', path: 'fund-tran', icon: require('assets/images/icons/account/history-1.svg') },
            { label: 'Chi tiết tặng quà', path: 'present-detail', icon: require('assets/images/icons/account/history-2.svg') },
            { label: 'Lịch sử cược', path: 'fund-bet', icon: require('assets/images/icons/account/history-3.svg') },
        ],
    },
    {
        title: 'Thông Báo',
        id: 'notify',

        group: [
            { label: 'Hoàn trả', path: 'agency-refund', icon: require('assets/images/icons/account/notify-3.svg') },
            { label: 'Tất cả thông báo', path: 'noti-all', icon: require('assets/images/icons/account/notify-1.svg') },
            { label: 'Tin nhắn', path: 'noti-inbox', icon: require('assets/images/icons/account/notify-2.svg') },
        ],
    },
    {
        title: 'Báo Cáo',
        id: 'report',

        group: [
            { label: 'Báo cáo tổng quan', path: 'stats-general', icon: require('assets/images/icons/account/report-1.svg') },
            { label: 'Báo cáo đại lý', path: 'stats-wl', icon: require('assets/images/icons/account/report-2.svg') },
            { label: 'Báo cáo hằng ngày', path: 'stats-daily', icon: require('assets/images/icons/account/report-3.svg') },
        ],
    },
    {
        title: 'Ví Tiền',
        id: 'wallet',

        group: [
            { label: 'Nạp Tiền', path: 'wl-depo', icon: require('assets/images/icons/account/wallet-4.svg') },
            { label: 'Rút Tiền', path: 'wl-wdr', icon: require('assets/images/icons/account/wallet-1.svg') },
            { label: 'Lịch sử Nạp/Rút', path: 'wl-depo-his', icon: require('assets/images/icons/account/wallet-2.svg') },
            { label: 'Chuyển Quỹ', path: 'fund-transfer', icon: require('assets/images/icons/account/wallet-3.svg') },
        ],
    },
]

export const optionAccountComponent: OptionAccountComponent[] = [
    { path: 'personal-info', component: PersonalInfo },
    { path: 'bank-account', component: BankAccount },
    { path: 'gift-code', component: GiftCodeAccount },
    { path: 'agent-sign', component: AgentSign },
    { path: 'agent-member', component: AgentMember },
    { path: 'agent-reg', component: AgentRegister },
    { path: 'agent-team-balance', component: AgentTeamBalance },
    { path: 'agency-refund', component: AgencyRefund },
    { path: 'fund-tran', component: FundAccountTransfer },
    { path: 'present-detail', component: PresentDetail },
    { path: 'fund-bet', component: FundBet },
    { path: 'noti-all', component: NotiftyAll },
    { path: 'noti-inbox', component: NotiftyInbox },
    { path: 'stats-general', component: StatsGeneral },
    { path: 'stats-wl', component: StatsAgency },
    { path: 'stats-daily', component: StatsDaily },
    { path: 'wl-depo-his', component: WalletDepositHistory },
    { path: 'wl-depo', component: DepositPage },
    { path: 'wl-wdr', component: WithdrawPage },
    { path: 'fund-transfer', component: FundTransfer },
];
